import axios from 'axios'

// 创建axios实例
const sipservice = axios.create({
  baseURL: 'http://sip.wecare-u.net',
  timeout: 5000
})

// request拦截器
sipservice.interceptors.request.use(config => {
  // config.baseURL = 'http://120.79.37.159'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
sipservice.interceptors.response.use(
  response => {
    // console.log(response.data)
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

export default sipservice



// WEBPACK FOOTER //
// ./src/sip/sip_axios.js